import { Scope } from "./interface";

export default function a8Astro(scope: Scope) {
    return `
        interface AstroOperations {
            create: (query: any, transactions?:any) => Promise<any>;
            createMany: (query: any, transactions?: any) => Promise<any>;
            find: (query: any, transactions?:any) => Promise<any>;
            delete: (query: any, transactions?: any) => Promise<any>;
            update: (query: any,transactions?:any) => Promise<any>;
            
        };
        type batchFn = () => {
            execute: any;
            [key:string]:any;
        }>;
        type connectFn = (connectionName: string, schemaDetails?: any) => Promise<{
            batchOperation: batchFn;
            ${scope !== 'functionClient' && scope !== 'inline' ? 'executeRawQuery: (query: string) => Promise<any>;' : ''}
            [key: string]: AstroOperations;
        }>;

        declare var a8Astro:{
            connect: connectFn
            [key: string]: AstroOperations
        }
    `
}